import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { RefreshCcwIcon, SearchXIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import i18n from '@/utils/i18n';

export function EmptyState() {
  return (
    <div className="tw:flex tw:justify-center tw:items-center">
      <Card>
        <Empty>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <SearchXIcon />
            </EmptyMedia>
            <EmptyTitle>{i18n.t('EventOrder:notFound')}</EmptyTitle>
            <EmptyDescription>
              {i18n.t('EventOrder:orderFormNotExist')}
            </EmptyDescription>
          </EmptyHeader>
          <EmptyContent>
            <Button
              variant="outline"
              size="sm"
              onClick={() => {
                window.location.reload();
              }}
            >
              <RefreshCcwIcon />
              {i18n.t('Common:refresh')}
            </Button>
            <EmptyDescription className="tw:flex tw:items-center tw:gap-2">
              {i18n.t('EventOrder:needHelp')}{' '}
              <a href="https://www.vytal.org/de/kontakt">
                {i18n.t('EventOrder:contactSupport')}
              </a>
            </EmptyDescription>
          </EmptyContent>
        </Empty>
      </Card>
    </div>
  );
}
